import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MessageComponent } from "./messaging/message/message.component";
import { MessagesContainerComponent } from "./messaging/messages-container/messages-container.component";
import { MessagingComponent } from "./messaging/messaging.component";
import { ServiceDataDetailComponent } from "./service-data/service-data-detail/service-data-detail.component";
import { ServiceDataComponent } from "./service-data/service-data.component";
import { DxButtonModule, DxDataGridModule, DxDropDownButtonModule, DxScrollViewModule, DxSelectBoxModule, DxSortableModule, DxTextAreaModule } from "devextreme-angular";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuardWithForcedLogin, PipesModule } from "acl-cloud-lib";
import { ReactiveFormsModule } from "@angular/forms";

const routes: Routes = [
  {
    path: 'message',
    component: MessagingComponent,
    canActivate: [AuthGuardWithForcedLogin],
    data: { breadcrumb: 'Messages' }
  },
  {
    path: 'service-data',
    component: ServiceDataComponent,
    canActivate: [AuthGuardWithForcedLogin],
    data: { roles: ['Right:MAINTAINER', 'Right:ADMIN', 'Right:SUPERADMIN'], breadcrumb: 'Service Data' }
  },
];

@NgModule({
  declarations: [
    MessagingComponent,
    MessageComponent,
    MessagesContainerComponent,
    ServiceDataComponent,
    ServiceDataDetailComponent
  ],
  imports: [
    DxButtonModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxDataGridModule,
    DxSortableModule,
    DxScrollViewModule,
    DxDropDownButtonModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule.forChild(routes),
    PipesModule
  ]
})
export class ColaborationModule { }
